export enum FormalityStatusEnum {
  formalityToCheck = 'formality_to_check',
  formalityClosed = 'formality_closed',
  outsourced = 'outsourced',
  liquidation = 'liquidation',
  abandoned = 'abandoned'
}
